module.exports = __webpack_public_path__ + "assets/img/shopping.232bbd1d.svg";